import { computed, ComputedRef, Ref, ref } from '@nuxtjs/composition-api';
import useBrandConfig from '@shared/composables/useBrandConfig';
import { AustralianState } from '@shared/types/locations';
import { StoreDetails } from '@shared/types/stores';

export interface UseStoresListConfig {
  storesList: { [state: string]: StoreDetails[] };
}

const useStoresList = (): {
  getStoresByState: (state: AustralianState) => void;
  getStoreByPlaceId: (placeId: string) => void;
  states: ComputedRef<AustralianState[]>;
  stores: Ref<StoreDetails[] | null>;
  store: Ref<StoreDetails | null>;
  error: Ref<unknown | null>;
} => {
  const { composableConfig } = useBrandConfig();
  const { storesList } = composableConfig.useStoresList;
  const stores = ref<StoreDetails[] | null>(null);
  const store = ref<StoreDetails | null>(null);
  const error = ref<unknown | null>(null);
  const states = computed(
    () =>
      Object.values(AustralianState).filter((s) =>
        Object.keys(storesList).includes(s),
      ) as AustralianState[],
  );

  const getStoresByState = (state: AustralianState) => {
    error.value = null;
    try {
      stores.value = storesList[state];
    } catch (err) {
      error.value = err;
      console.error(err);
    }
  };

  const getStoreByPlaceId = (placeId: string) => {
    error.value = null;
    try {
      const storeDetails = Object.values(storesList);
      store.value = storeDetails.flat().find((store) => store.placeId === placeId) || null;
    } catch (err) {
      error.value = err;
      console.error(err);
    }
  };

  return {
    getStoresByState,
    getStoreByPlaceId,
    states,
    stores,
    store,
    error,
  };
};

export default useStoresList;
